import type { RouteRecordRaw } from 'vue-router';

/** Public marketing homepage — the platform's root entry on the central
 *  domain. `skipTenantGuard` lets it render without an auth/tenant context;
 *  the tenant guard redirects subdomain visitors into their app instead. */
export const homeRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('./pages/HomePage.vue'),
    meta: { title: 'Home', requiresAuth: false, skipTenantGuard: true, isPublicHome: true },
  },
];
